const ACTIVE_CLASS = 'is-active';

export default function initNavigation() {
  const $toggler = document.getElementById('main-nav-toggle');
  const $menu = document.getElementById('main-nav');
  const $submenuTogglers = $menu.querySelectorAll('[data-submenu-toggle]');

  $toggler.addEventListener('click', e => {
    e.preventDefault();
    $toggler.classList.toggle(ACTIVE_CLASS);
    $menu.classList.toggle(ACTIVE_CLASS);
    document.documentElement.classList.toggle('menu-open');
  });

  if ($submenuTogglers) {
    const closeOtherSubmenus = (submenuId) => {
      const submenus = $menu.querySelectorAll('[data-submenu]');

      if (submenus) {
        const filteredSubmenus = [...submenus].filter((submenu) => {
          return submenu.dataset.submenu !== submenuId;
        });

        filteredSubmenus.forEach(submenu => {
          submenu.classList.remove(ACTIVE_CLASS);
        })
      }
    }

    $submenuTogglers.forEach(toggler => {
      toggler.addEventListener('click', e => {
        const href = toggler.getAttribute('href');
        if (href && href !== '#') {
          return;
        }

        e.preventDefault();

        const itemId = toggler.dataset.submenuToggle;
        const submenu = $menu.querySelector(`[data-submenu='${itemId}']`);

        if (submenu) {
          closeOtherSubmenus(itemId);
          submenu.parentElement.classList.toggle(ACTIVE_CLASS);
          submenu.classList.toggle(ACTIVE_CLASS);
        }
      })
    })
  }
}
